


























































import {Component, Vue, Watch} from "vue-property-decorator";
import TimeTrackingTimeTable from "@/views/Service/TimeTracking/TimeTable/TimeTrackingTimeTable.vue";
import TimeTrackingNewRecord from "@/views/Service/TimeTracking/NewRecord/TimeTrackingNewRecord.vue";
import TimeTrackingStatistics from "@/views/Service/TimeTracking/Statistics/TimeTrackingStatistics.vue";
import Accordions from "@/components/Accordion/Accordions.vue";
import Accordion from "@/components/Accordion/Accordion.vue";
import TimeTrackingRunningRecord from "@/views/Service/TimeTracking/RunningRecord/TimeTrackingRunningRecord.vue";
import {Action, Getter, Mutation} from "vuex-class";
import AccordionTs from "@/components/Accordion/AccordionTs.vue";
import TimeTrackingExport from "@/views/Service/TimeTracking/Export/TimeTrackingExport.vue";
import Modal from "@/components/Modal/Modal.vue";
import ModalCard from "@/components/Modal/ModalCard.vue";
import ContinueRecord from "@/views/Service/TimeTracking/Modals/ContinueRecord.vue";
import AuthService from "@/service/AuthService";
import TimeTrackingNewTask from "@/views/Service/TimeTracking/NewTask/TimeTrackingNewTask.vue";
import ITimeTrackingRecord from "@/models/TimeTracking/ITimeTrackingRecord";
import AppConfig from "@/config/AppConfig";
import ITimeTrackingTask from "@/models/TimeTracking/ITimeTrackingTask";


const NAMESPACE_TIME_TRACKING_RECORD: string = 'timeTrackingRecords';
const RESOURCE_TIME_TRACKING_RECORD: string = 'tt/record';

@Component({
  components: {
    TimeTrackingNewTask,
    ContinueRecord,
    ModalCard,
    Modal,
    TimeTrackingExport,
    AccordionTs,
    TimeTrackingRunningRecord,
    Accordion, Accordions, TimeTrackingStatistics, TimeTrackingNewRecord, TimeTrackingTimeTable
  }
})
export default class TimeTrackingOverview extends Vue {
  public name: string = "TimeTrackingOverview";

  @Action('loadUsersRunningRecord', {namespace: NAMESPACE_TIME_TRACKING_RECORD}) loadUsersRunningRecord: any;

  @Getter('getRunningRecord', {namespace: NAMESPACE_TIME_TRACKING_RECORD}) runningTimeTrackingRecord: any;

  @Mutation('ADD_RECORD_ON_TOP', {namespace: NAMESPACE_TIME_TRACKING_RECORD}) addRecordOnTop: any;
  @Mutation('SET_RUNNING_RECORD', {namespace: NAMESPACE_TIME_TRACKING_RECORD}) setRunningRecord: any;

  @Watch('runningTimeTrackingRecord', {immediate: true, deep: true})
  onRunningTimeTrackingRecordChanged() {

    if (this.runningTimeTrackingRecord) {
      this.selectedAccordion = 0;
    }

  }

  private selectedAccordion: number = 1;
  private isTimeTrackingNewRecordVisible: boolean = false;
  private isTimeTrackingNewTaskVisible: boolean = false;


  private authService: any = new AuthService();
  private currentUserId: number = this.authService.getUserId();

  private isContinueRecordVisible: boolean = false;
  private newTimetrackingRecordPresets: any | null = null;


  private onTimetrackingRecordStopped() {
  }

  private onContinueTask(task: ITimeTrackingTask) {

    this.newTimetrackingRecordPresets = Object.assign({}, task);


    this.isContinueRecordVisible = true;

  }

  private onContinueRecordActiveChanged(active: boolean) {

    if (!active) {

      this.newTimetrackingRecordPresets = null;

    }

    this.isContinueRecordVisible = active;

  }

  private onFloatButtonClicked() {

    if (this.$route.name === 'TimeTracking-Overview-TasksTable') {

      this.onNewTimetrackingTask();

      return;

    }

    this.onNewTimetrackingRecord();

  }

  private onNewTimetrackingRecord() {

    this.isTimeTrackingNewRecordVisible = true;

  }

  private onNewTimetrackingTask() {

    this.isTimeTrackingNewTaskVisible = true;

  }


  private onTimeTrackingNewRecordActiveChanged(active: boolean) {

    if (!active) {

      //   this.newTimetrackingRecordPresets = null;

    }

    this.isTimeTrackingNewRecordVisible = active;

  }

  private onTimeTrackingNewTaskActiveChanged(active: boolean) {

    this.isTimeTrackingNewTaskVisible = active;

  }


  private setTimeTrackingRecordChannel(id: number) {

    this.$echo.private(`TimeTrackingRecord.${id}`)
        .listen('TimeTracking\\UserHasStartedNewRecord', (e) => {

          this.addRecordOnTop(e.timeTracking);
          this.setRunningRecord(e.timeTracking);

        });

  }

  created() {

    if (!this.runningTimeTrackingRecord) {
      this.loadUsersRunningRecord({resource: RESOURCE_TIME_TRACKING_RECORD});
    }

  }

  mounted() {

    this.setTimeTrackingRecordChannel(this.currentUserId);

  }


}
